<template>
    <draggable 
        v-bind="dragOptions"
        tag="div"
        :list="list"
        :value="value"
        @input="emitter"
        class="overflow-auto space-y-1 hide-scroll"
    >
        <div id="item" v-for="(note, id) in realValue" :key="id" class="text-xs text-gray-700">
            <div v-if="note">
                <div @click="selectNote(note)" v-if="!note.folder" class="cursor-pointer rounded-full p-1 px-2 border truncate group" :class="noteData.id == note.id ? 'text-primary border-gray-400 bg-white' : 'border-transparent hover:bg-gray-200'">
                    <div class="flex items-center">
                        <div class="mr-2">
                            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="document-text w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"></path></svg>
                        </div>
                        <div class="flex-1 truncate pr-2">
                            {{getTitle(note.content)}}
                        </div>
                        <div class="text-gray-500 hover:text-gray-700 cursor-pointer hidden group-hover:block" @click.stop.prevent="removeNote(note)" v-tooltip="{content: 'Delete note', placement: 'left'}">
                            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="trash w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                        </div>
                    </div>
                </div>

                <div v-if="note.folder" class="rounded-full border border-transparent p-1 px-2 mb-1 truncate group hover:bg-gray-200 cursor-default">
                    <div class="flex items-center">
                        <div v-if="note.editable" class="mr-2">
                            <svg viewBox="0 0 20 20" fill="currentColor" class="pencil w-4 h-4"><path d="M13.586 3.586a2 2 0 112.828 2.828l-.793.793-2.828-2.828.793-.793zM11.379 5.793L3 14.172V17h2.828l8.38-8.379-2.83-2.828z"></path></svg>
                        </div>
                        <div v-else>
                            <div class="mr-2" v-if="note.notes.length > 0">
                                <svg viewBox="0 0 20 20" fill="currentColor" class="folder-open w-4 h-4"><path fill-rule="evenodd" d="M2 6a2 2 0 012-2h4l2 2h4a2 2 0 012 2v1H8a3 3 0 00-3 3v1.5a1.5 1.5 0 01-3 0V6z" clip-rule="evenodd"></path><path d="M6 12a2 2 0 012-2h8a2 2 0 012 2v2a2 2 0 01-2 2H2h2a2 2 0 002-2v-2z"></path></svg>
                            </div>
                            <div class="mr-2" v-else>
                                <svg viewBox="0 0 20 20" fill="currentColor" class="folder w-4 h-4"><path d="M2 6a2 2 0 012-2h5l2 2h5a2 2 0 012 2v6a2 2 0 01-2 2H4a2 2 0 01-2-2V6z"></path></svg>
                            </div>
                        </div>
                        <div class="flex-1 truncate pr-2 font-bold" @dblclick="note.editable = true">
                            <div v-if="note.editable === true">
                                <form @submit.prevent="submitFolderChange(note)">
                                    <input type="text" v-model="note.content" v-focus v-shortkey="['esc']" @shortkey="note.editable = false" class="w-full font-medium focus:outline-none h-full bg-transparent" />
                                </form>
                            </div>
                            <div v-else>
                                <span v-tooltip="{content: 'Double click to change folder name'}">{{note.content}} ({{note.notes.length}})</span>
                            </div>
                        </div>
                        <div class="text-gray-500 hover:text-gray-700 hidden group-hover:block cursor-pointer" @click.stop.prevent="removeNote(note)" v-tooltip="{content: 'Delete folder', placement: 'left'}">
                            <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="trash w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                        </div>
                    </div>
                </div>

                <note-list v-if="note.folder" class="ml-4" :list="note.notes" :key="note.id + '_' + note.notes.length" />

            </div>
            <!-- <div class="flex items-stretch">
                <div class="w-1" :class="noteData.id == note.id ? 'bg-primary' : 'bg-gray-400'"></div>
                <div class="handle flex items-center p-2 text-gray-500 cursor-move">
                    <svg viewBox="2 0 10 20" fill="currentColor" class="dots-vertical w-2 h-4"><path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path></svg>
                    <svg viewBox="5 0 10 20" fill="currentColor" class="dots-vertical w-2 h-4"><path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path></svg>
                </div>
                <div class="flex-1 p-4 pl-2 pr-6 overflow-hidden relative">
                    <div class="absolute top-0 right-0 p-2 text-gray-500 hover:text-gray-700 cursor-pointer" @click.stop.prevent="removeNote(note)" v-tooltip="{content: 'Delete note', placement: 'left'}">
                        <svg fill="none" viewBox="0 0 24 24" stroke="currentColor" class="trash w-4 h-4"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path></svg>
                    </div>
                    <div class="font-bold truncate">{{getTitle(note.content)}}</div>
                    <div class="text-sm text-gray-500">{{getContent(note.content).slice(0,25)}}...</div>
                </div>
            </div> -->
        </div>
    </draggable>
</template>

<script>
    import draggable from "vuedraggable";
    import { mapState } from 'vuex';
    import NoteList from './NoteList.vue';
    import moment from 'moment';
    
    export default {
        name: "NoteList",
        components: {
            draggable, NoteList
        },
        props: {
            value: {
                required: false,
                type: Array,
                default: null
            },
            list: {
                required: false,
                type: Array,
                default: null
            }
        },
        computed: {
            dragOptions() {
                return {
                    animation: 1,
                    group: "notes",
                    disabled: false,
                    ghostClass: "ghost"
                };
            },
            ...mapState(['noteData']),
            // this.value when input = v-model
            // this.list  when input != v-model
            realValue() {
                return this.value ? this.value : this.list;
            }
        },
        methods: {
            submitFolderChange (note) {
                note.editable = false;
                note.updated = moment().toISOString();
            },
            emitter(value) {
                this.$emit("input", value);
            },
            removeNote (note) {
                if (note) {
                    if (confirm('Are you sure?')) {
                        this.$store.dispatch('removeNote', note);
                    }
                }
            },
            getTitle (content) {
                var firstLine = content.split('\n')[0];
                var title = firstLine.replace('#', '');

                return title || 'Start writing your notes here';
            },
            selectNote(id) {
                this.$store.dispatch('showNote', id);
            }
        },
    };
</script>

<style>

</style>